import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import './css/bootstrap.css';
import './css/custom.css';
import './css/master.css';
import './css/color.css';
import './css/fontawesome.css';
import './css/fullcalendar.min.css';
import './css/login.css';
import './css/react-datepicker.css';
import './css/respond.css';
import './css/select2_3.4.5.css';
import './css/typehead.css';
import axios from 'axios';
import constants from './constants';
import sha1 from 'js-sha1';
import { cookieStorageUtility, /* getUserIP,  */localStorageUtility } from './utils/utilityFunctions';
import { getAES } from './utils/encryptDecrypt';

const theme = createTheme();
// comment to de-activate sso login
// sso login start
const { ENCRYPTOR_KEY, SSO_AUTH_URL, REDIRECT_URL, APP_KEY } = constants;
const requestInterceptors = () => {
  // axios.interceptors.request.use(async(request) => {
  axios.interceptors.request.use((request) => {
    if (identity !== null) {
      /* let activity_ip = '';
      await getUserIP().then((res) => {
        activity_ip = res.query;
      }); */
      const activityUserDetails = {
        activity_user_id: identity.user_id,
        activity_ip: '127.0.0.1'
      };
      // const token = request.headers.token;
      // console.log(getAES(atob(token)));
      request.headers.activity = getAES(activityUserDetails);

    }
    // Do something with response data
    return request;
  });
};
requestInterceptors();
const ssoAuthentication = () => {

  const authUserId = cookieStorageUtility.fetch('auth_user_id');
  const { serverUrl, SSO_USER_ENCYPTER } = constants;
  const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

  const data = {
    sso_user_id: authUserId
  };

  if (sha1(authUserId + '-' + SSO_USER_ENCYPTER) === encryptedToken) {
    axios(serverUrl + 'users/ssoauth', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data
    }).then(response => {
      if (response.data.status === 'success') {
        localStorageUtility.create('identity', response.data.data);
        cookieStorageUtility.create('hotelId', response.data.data.hotel_id);
        window.location.reload();
      } else {
        // window.open(SSO_AUTH_URL + 'auth?redirect_url=' + REDIRECT_URL + '&app_key=' + APP_KEY, '_self');
      }
    }).catch(error => {
      console.log(error);
      window.open(SSO_AUTH_URL + 'auth?redirect_url=' + REDIRECT_URL + '&app_key=' + APP_KEY, '_self');
    });
  } else {
    window.open(SSO_AUTH_URL + 'auth?redirect_url=' + REDIRECT_URL + '&app_key=' + APP_KEY, '_self');
  }
};
const identity = localStorageUtility.fetch('identity');
if (identity === null) {
  ssoAuthentication();

  // console.log('SSO Authentication initiated');
}
// sso login end
const logout = () => {
  localStorageUtility.delete('identity');
  localStorageUtility.delete('isLoggedIn');
  cookieStorageUtility.delete('hotelId');
  cookieStorageUtility.delete('auth_user_id');
  cookieStorageUtility.delete('encrypted_' + ENCRYPTOR_KEY + '_token');
  cookieStorageUtility.delete('lastLogedInActivityAt');
  // window.open(REDIRECT_URL, '_self'); // uncomment for login screen
  window.open(SSO_AUTH_URL + 'sign_out?redirect_url=' + REDIRECT_URL + '&app_key=' + APP_KEY, '_self'); // comment to de-activate sso login
};

const verifyAxiosResponse = () => {
  axios.interceptors.response.use((response) => {
    // Do something with response data
    return response;
  }, (error) => {
    // Do something with response error
    if (error.response.status === 401) {
      logout();
      return false;
    } else {
      return error;
    }
  });
};
verifyAxiosResponse();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
